module.exports = __webpack_public_path__ + "static/media/YesicaCynthiaViverosLopez.328810d1.jpg";